package com.cybersoftsolution.cybersoftsolutionweb.models

import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources


data class WorkFlow(
    override var id: String?,
    val name:String,
    val description:String?,
    val items:List<String>,
    val extensiveItems:List<String> = listOf(),
    val image:String,
    override var selected: Boolean = false,
):MyElement()

val ourWorkFlow = listOf(
    WorkFlow(
        id = "work-flow-1",
        name = "Análisis y Planificación",
        description = null,
        items = listOf(
            "Comprensión del proyecto",
            "Recopilación de información",
            "Definiciones y alcance",
            "Lista de requisitos",
            "Selección de tecnologías",
            "Elaboración del plan de desarrollo",
        ),
        image = Resources.ImagesWorkFlows.planing,
        extensiveItems = listOf(
        )
    ),
    WorkFlow(
        id = "work-flow-2",
        name = "Estructura y Diseño",
        description = null,
        items = listOf(
            "Arquitectura del sistema",
            "Diseño de la base de datos",
            "Manejo y persistencia de datos",
            "Diseño de la interfaz gráfica",
            "Estructura y flujo de la informacion",
            "Estrategias de escalabilidad",

        ),
        image = Resources.ImagesWorkFlows.design,
        extensiveItems = listOf(
        )
    ),
    WorkFlow(
        id = "work-flow-3",
        name = "Desarrollo y Pruebas",
        description = null,
        items = listOf(
            "Implementar la arquitectura segun el plan de desarrollo",
            "Desarrollo iterativo e incremental",
            "Uso de plataformas para el versionado y la colaboración",
            "Codificación, depuración y compilación",
            "Pruebas unitarias, de integración y funcionales",
            ),
        image = Resources.ImagesWorkFlows.development,
        extensiveItems = listOf(
        )
    ),
    WorkFlow(
        id = "work-flow-4",
        name = "Implementación y Despliegue",
        description = null,
        items = listOf(
            "Configuración de servidores y sistemas en la nube",
            "Implementación de sistemas de seguridad y dependencias para el entorno",
            "Despliegue e instalación del nuevo software",
            "Pruebas en producción, validación de datos y monitoreo",
        ),
        image = Resources.ImagesWorkFlows.deploy,
        extensiveItems = listOf(
        )
    ),
    WorkFlow(
        id = "work-flow-5",
        name = "Soporte y Mantenimiento",
        description = null,
        items = listOf(
            "Documentación, soporte técnico y capacitación",
            "Mantenimiento correctivo",
            "Análisis y metricas de rendimiento",
            "Mejoras bajo demanda o adaptativas",
        ),
        image = Resources.ImagesWorkFlows.support,
        extensiveItems = listOf(
        )
    ),



)

